import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App";
import "./index.css";
import { syncExistingSubscription } from "./lib/push";

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0.1,
  });
}

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then(() => {
        // Don't prompt on load — that's handled by the in-app nudge from a
        // user gesture. Only re-register if the user already granted access.
        syncExistingSubscription();
      })
      .catch((err) => console.warn("[SW] Registration failed:", err));
  });
}

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary
    fallback={
      <div style={{ padding: 24, fontFamily: "system-ui, sans-serif" }}>
        <h1>Something went wrong</h1>
        <p>We've been notified and are looking into it. Try refreshing the page.</p>
      </div>
    }
  >
    <App />
  </Sentry.ErrorBoundary>,
);
